import React from 'react';
import { Button } from 'tfc-components';

import Container from '../Container';

import mapModifiers from 'utils/functions';

interface FooterCheckoutProps {
  step: number;
  action: () => void;
  actionBack: () => void;
  disabled?: boolean;
}

const FooterCheckout: React.FC<FooterCheckoutProps> = ({
  step, actionBack, action, disabled
}) => (
  <footer className="o-footerCheckout">
    <Container>
      <div className="o-footerCheckout_wrap">
        {step > 1 ? <Button onClick={() => actionBack()} extendClasses="o-footerCheckout_buttonBack">Back</Button>
          : <div />}
        {step < 3 && <Button disabled={disabled} onClick={() => action()} variant="primary" extendClasses={mapModifiers('o-footerCheckout_button', disabled && 'disabled')}>Next</Button>}
      </div>
    </Container>
  </footer>
);

export default FooterCheckout;
